export default class LocalizationsHelper {
    static get(key) {
        return craft.localization[key] || key;
    }
}